export default {
  namespaced: true,
  state: {
    // The supervisors currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
  },
  getters: {
    find: state => id => state.active.find(supervisor => supervisor.id == id),
  },
  mutations: {
    setActive(state, { items = [] }) {
      state.active = items
      state.loading = false
    },
    set(state, supervisor) {
      state.active = state.active.filter(o => o.id != supervisor.id)
      state.active.push(supervisor)
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    },
  },
  actions: {
    create({ commit }, { supervisor, experienceId }) {
      this.$authorize('create', 'Supervisor')

      return Vue.$http
        .post(`admin/experiences/${experienceId}/supervisors`, { supervisor })
        .then(response => {
          commit(
            'snackbar',
            { text: 'Supervisor was created successfully', type: 'success' },
            { root: true }
          )
          commit('set', response.data)
          return response.data
        })
        .catch(error => {
          commit(
            'snackbar',
            { text: 'There was a problem creating the supervisor', type: 'error' },
            { root: true }
          )
          return Object.assign(supervisor, error.response && error.response.data)
        })
    },
    update({ commit }, { supervisor, experienceId }) {
      this.$authorize('update', 'Supervisor')

      return Vue.$http
        .patch(`admin/experiences/${experienceId}/supervisors/${supervisor.id}`, { supervisor })
        .then(({ data }) => {
          commit(
            'snackbar',
            { text: 'Supervisor was updated successfully', type: 'success' },
            { root: true }
          )
          commit('set', data)
          return data
        })
        .catch(error => {
          commit(
            'snackbar',
            { text: 'There was a problem updating the supervisor', type: 'error' },
            { root: true }
          )
          return Object.assign(supervisor, error.response && error.response.data)
        })
    },
    destroy({ commit }, { id, experienceId }) {
      this.$authorize('delete', 'Supervisor')

      return Vue.$http
        .delete(`admin/experiences/${experienceId}/supervisors/${id}`)
        .then(response => {
          commit('remove', id)
          commit(
            'snackbar',
            { text: 'You have removed this supervisor', type: 'success' },
            { root: true }
          )
        })
        .catch(() =>
          commit(
            'snackbar',
            { text: 'Unfortunately the supervisor could not be removed', type: 'error' },
            { root: true }
          )
        )
    },
  },
}
